import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
// import Button from 'react-bootstrap/Button';
import Button from '@mui/material/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Dropdown from 'react-bootstrap/Dropdown';
import TextField from '@material-ui/core/TextField';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import './Card.css';
import Modal from 'react-bootstrap/Modal';
import { Card, Form } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import Barcode from 'react-barcode';
import { AddToValidationCart } from '../../redux/slices/inventory/inventory.thunks';
import { AddToCart } from "../../redux/slices/inventory/inventory.thunks";
//import { Removefromcart } from '../../redux/slices/inventory/inventory.thunks';
import { updateBadge } from '../../redux/slices/inventory/inventory.thunks';
import firebase, { firestore } from '../../config/firebaseConfig'
import { number } from 'prop-types';
import { isDesc } from '@material-ui/data-grid';
import { epochToDate } from 'src/shared/functions/toDateTime';
import itemImg from "../../assert/whey.jpg";
import { FaBars } from 'react-icons/fa';

// const Popup = ({ isOpen, onClose, children }) => {
//   return (
//     <div className={`popup ${isOpen ? 'open' : ''}`}>
//       <div className="popup-content">
//         {children}
//         <button onClick={onClose}>Close</button>
//       </div>
//     </div>
//   );
// };
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};



//https://mui.com/base-ui/react-popup/
export function Cards({ lb,id, lastprice, formouth, title, imageurl, body, QuantityCasa, QuantityDekon,QuantityInPO, QuantityInShpping, QuantityToBuy, RestQtyToBuy,Fournisseur,OrderInfos }) {
  //console.log("Infos: "+lb+ "UPC: "+body)
  const ComposeFilter = JSON.parse(localStorage.getItem('ComposeFilter'));
const idVendor = ComposeFilter.delivery.vendor.id;
const vendorname = ComposeFilter.delivery.vendor.name;
  function MyVerticallyCenteredModal(props) {
    const [fiches,setItemfiche]= useState([])
    const fetchFiche=async()=>{
  //     let itemsRef = firestore.collection('items').doc(id);

  //     itemsRef.get().then((doc) => {
  //       if (doc.exists) {
  //           // Document exists, you can access its data using doc.data()
  //           const data = doc.data();
            console.log(OrderInfos)
            setItemfiche(OrderInfos)
  //           console.log("Document data:", data.OrderInfo);
  //       } else {
  //           // Document does not exist
  //           console.log("No such document!");
  //       }
  //   }).catch((error) => {
  //       console.log("Error getting document:", error);
  //   });
    }

    
  useEffect(() =>{
     fetchFiche();
  })
    
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <div><img src={imageurl} alt='...' style={{position:"center",alignItems:"center",width:"150px",height:"150px"}}/><br/>
            <p style={{fontSize:"20px",fontWeight:"10",fontFamily: "Poppins"}}>UPC: {body} </p></div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4 style={{fontSize:"20px",fontWeight:"10",fontFamily: "Poppins"}}>Fiche commande</h4>

          <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell style={{fontSize:"20px",fontWeight:"10",fontFamily: "Poppins"}}>Name or Email</TableCell>
            <TableCell align="right" style={{fontSize:"20px",fontWeight:"10",fontFamily: "Poppins"}}>Action</TableCell>
            <TableCell align="right" style={{fontSize:"20px",fontWeight:"10",fontFamily: "Poppins"}}>Qte Old</TableCell>
            <TableCell align="right" style={{fontSize:"20px",fontWeight:"10",fontFamily: "Poppins"}}>Qte New</TableCell>
            <TableCell align="right" style={{fontSize:"20px",fontWeight:"10",fontFamily: "Poppins"}}>Vendors</TableCell>
            <TableCell align="right" style={{fontSize:"20px",fontWeight:"10",fontFamily: "Poppins"}}>Update At</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {fiches && fiches.map(fiche =>(
            <TableRow
              // key={row.name}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row" style={{fontSize:"20px",fontWeight:"10",fontFamily: "Poppins"}}>
              {fiche['user']}
              </TableCell>
              <TableCell align="right" style={{fontSize:"20px",fontWeight:"10",fontFamily: "Poppins"}}>{fiche['todo']}</TableCell>
              <TableCell align="right" style={{fontSize:"20px",fontWeight:"10",fontFamily: "Poppins"}}>{fiche['qOld']}</TableCell>
              <TableCell align="right" style={{fontSize:"20px",fontWeight:"10",fontFamily: "Poppins"}}>{fiche['qNew']}</TableCell>
              <TableCell align="right" style={{fontSize:"20px",fontWeight:"10",fontFamily: "Poppins"}}>{fiche['vendors']}</TableCell>
              <TableCell align="right" style={{fontSize:"20px",fontWeight:"10",fontFamily: "Poppins"}}>{new Date(fiche['updateAt'].seconds * 1000).toLocaleString()}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>          
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={props.onHide}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  }
  
  const [newQty, setNewQtyValue] = useState('');
  const handleQtyChange = (event) => {
    setNewQtyValue(event.target.value);
  };
  const [modalShow, setModalShow] = React.useState(false);
  
 const handleForvalidationCart = ids =>{
  const QtoBuy = Number(QuantityInPO)+Number(QuantityInShpping)+Number(newQty);
  const name = firebase.auth()?.currentUser?.displayName ?  firebase.auth()?.currentUser?.displayName : firebase.auth()?.currentUser?.email;
  AddToValidationCart({itemid: id, newQToBuy: QtoBuy, newQuantity: newQty, OldQuantity: QuantityToBuy,username: name,Restant:RestQtyToBuy});
}
 const handleaddToCart= ids => {
  const QtoBuy = Number(QuantityInPO)+Number(QuantityInShpping)+Number(newQty);
  const name = firebase.auth()?.currentUser?.displayName ?  firebase.auth()?.currentUser?.displayName : firebase.auth()?.currentUser?.email;
  AddToCart({itemid: id, newQToBuy: QtoBuy, newQuantity: newQty, OldQuantity: QuantityToBuy,username: name,Restant:RestQtyToBuy});
}

  // const handleRemovefromcart= ids => {
  //   const name = firebase.auth()?.currentUser?.displayName ?  firebase.auth()?.currentUser?.displayName : firebase.auth()?.currentUser?.email;
  //   Removefromcart({itemid: id, newQuantity: QuantityToBuy, OldQuantity: RestQtyToBuy,username: name,Restant:RestQtyToBuy});
  //   //alert("Remove From Cart");
  // };

   const Getoutpurchase=()=>{
    alert("OUT OF PURCHASE")
  };
  

  const handlebadgenormal= ids => {
    let badge = "3"
    updateBadge({itemid: id,niveau: badge});
  }
  const handlebadgeurgent= ids => {
    let badge = "1"
    updateBadge({itemid: id,niveau: badge});
  }
  const handlebadgemoinsurgent= ids => {
    let badge = "2"
    updateBadge({itemid: id,niveau: badge});
  }
  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <ButtonGroup>
      <Button
        variant="outline-secondary"
        ref={ref}
        onClick={(e) => {
          e.preventDefault();
          onClick(e);
        }}
      >
        <FaBars />
      </Button>
    </ButtonGroup>
  ));

    return (
      <div className="col-sm-3">
        <div className="card-container" id={"card"+id}>
        <p style={{fontSize:"20px",fontWeight:"10",fontFamily: "Poppins",color:"red",textAlign:"center",marginTop:"15px"}}>${lastprice?lastprice:0} -{OrderInfos == null ? 0 : OrderInfos.length}-    <Chip label={lb ? lb == "1" ? 'Tres urgent' : lb == "2" ? 'Moins urgent' : 'Normal' : 'Normal'} color={lb && lb === "3" ? "success" : lb && lb === "2" ? "primary" : lb && lb === "1" ? "secondary" : "success"} background="red" style={{marginLeft:"5px",position:"absolute"}} /></p>
    <Dropdown as={ButtonGroup} style={{backgroundColor:"white",margin:0,position: "absolute"}}>
      {/* <Dropdown.Toggle   id="dropdown-split-basic" style={{margin:"auto"}} /> */}
      <Dropdown.Toggle as={CustomToggle} id="dropdown-split-basic" />
      <Dropdown.Menu
          align="end"
          title="Menu Manager"
          id="dropdown-menu-align-end"   
          style={{overflowY:"auto",maxHeight:"500px",left:"auto",right:0}}
       >
      <div style={{borderColor:"red",borderWidth:4,display:"center",right:"20%"}}>
      <p style={{alignContent:"center"}}><Barcode value={body} /></p>
      <p style={{textAlign:'center',margin:"5px",fontSize:"20px",fontWeight:"10",fontFamily: "Poppins"}}>For month: {formouth} | Prevu: {formouth*3}</p>
      <TextField
        label="ex:1"
        variant="outlined"
        value={newQty}
        onChange={handleQtyChange}
        style={{width:"auto",margin:"5px"}}
      />
      <Button variant="contained" color='warning' disableElevation style={{width:"200px",margin:"5px",fontSize:"12px",fontWeight:"10",fontFamily: "Poppins"}}
      onClick={()=>handleForvalidationCart(id)}>
        FOR VALIDATION
      </Button>
      <br />
      <Button  style={{width:"auto",margin:"5px",fontSize:"12px",fontWeight:"10",fontFamily: "Poppins"}} onClick={()=>handleaddToCart(id)}>
        ADD TO CART - {vendorname}
      </Button>
      <br />
      {/* <Button variant="contained" disableElevation color="error" style={{width:"200px",margin:"5px",fontSize:"12px",fontWeight:"bold"}} onClick={()=>handleRemovefromcart(id)}>
        REMOVE FROM CART
      </Button><br /> */}
      <Button variant="contained" disableElevation color="error" style={{width:"200px",margin:"5px",fontSize:"12px",fontWeight:"10",fontFamily: "Poppins"}} onClick={()=>Getoutpurchase()}>
        GET OUT OF PURCHASE
      </Button><br/>
      <Button variant="contained" disableElevation style={{width:"200px",margin:"5px",fontSize:"12px",fontWeight:"10",fontFamily: "Poppins"}} onClick={() => setModalShow(true)}>
        FICHE DE COMMANDE
      </Button>
      <br />
      <Button variant="contained" color='error' disableElevation style={{width:"200px",margin:"5px",fontSize:"12px",fontWeight:"10",fontFamily: "Poppins"}} onClick={()=>handlebadgeurgent(id)}>
        TRES URGENT
      </Button>
      <br />
      <Button variant="contained" color='warning' disableElevation style={{width:"200px",margin:"5px",fontSize:"12px",fontWeight:"10",fontFamily: "Poppins"}} onClick={() => handlebadgemoinsurgent(id)}>
        MOINS URGENT
      </Button>
      <br />
      <Button variant="secondary" disableElevation style={{width:"200px",margin:"5px",fontSize:"12px",background:"black",fontWeight:"10",fontFamily: "Poppins",color:"white"}} onClick={() => handlebadgenormal(id)}>
        NORMAL
      </Button>
      <br />
      <Button variant="contained" disableElevation style={{width:"200px",margin:"5px",fontSize:"12px",fontWeight:"10",fontFamily: "Poppins"}} onClick={() => setModalShow(true)}>
        MA LIMITE
      </Button>
      <br />
      </div>

      </Dropdown.Menu>
    </Dropdown>
    {/* <Chip
  label={lb && lb === "3" ? 'Normal' : lb && lb === "2" ? 'Moins urgent' : lb && lb === "1" ? 'Urgent' : 'Normal'}
  color={lb && lb === "3" ? 'yellow' : lb && lb === "2" ? 'yellow' : lb && lb === "1" ? 'red' : 'yellow'}
  variant="outlined"
/> */}


    {/* <Stack direction="row" spacing={1}> */}
    {/* <Chip label={lb} color={lb === "normal" ? 'orange' : 'red'} variant="outlined" /> */}
    {/* </Stack> */}
    

    <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
          {/* <p>{lb}</p> */}
          <div className="image-container">
            <img src={imageurl} alt="..."/>
          </div>
          <div className="card-content">
            <h5 className="title-container">
              {title}
            </h5>
            <div className="body-container" style={{padding: "30px",margin: "10px",textAlign:"center",fontSize:"14px"}}>
              <p style={{fontSize:"20px",fontWeight:"10",fontFamily: "Poppins"}}>{body}</p>
              <p>
                <Box component="div" sx={{ display: 'inline' }} style={{fontSize:"20px",fontWeight:"10",fontFamily: "Poppins"}}>PO: {QuantityInPO}</Box> | 
                <Box component="div" sx={{ display: 'inline' }} style={{fontSize:"20px",fontWeight:"10",fontFamily: "Poppins"}}>Ship: {QuantityInShpping}</Box>
              </p>
              <p>
                <Box component="div" sx={{ display: 'inline' }} style={{fontSize:"20px",fontWeight:"10",fontFamily: "Poppins",marginLeft: "5px"}}>Casa: {QuantityCasa}</Box> | 
                <Box component="div" sx={{ display: 'inline' }} style={{fontSize:"20px",fontWeight:"10",fontFamily: "Poppins"}}>Dekon: {QuantityDekon}</Box>
              </p>
              <p>
                <Box component="div" sx={{ display: 'inline' }} style={{marginLeft: "5px",fontSize:"20px",fontWeight:"10",fontFamily: "Poppins"}}>To Buy: {QuantityToBuy}</Box> | 
                <Box component="div" sx={{ display: 'inline' }} style={{fontSize:"20px",fontWeight:"10",fontFamily: "Poppins",color:"red"}}>Rest: {RestQtyToBuy}</Box>
              </p>
              
            </div>
          </div>
          {/* <div className="btn"> */}
            {/* <button onClick={onActionClick}>
              Action Button
            </button> */}
          {/* </div> */}
        </div>
      </div>
    );
  }
  